export default __webpack_public_path__ + "static/media/breakfast-overlay.9f4fee8e.png";